export class GuildSearchResultDTO {
  constructor() {
    this.guild_id = null;
    this.name = null;
    this.logo = null;
    this.alpha = null;
    this.members = null;
  }
}